import { Fragment } from 'react';
import CountByHourCard from '../../../components/dashboard/traffic/CountByHourCard';
import TimeOfDayCard from '../../../components/dashboard/traffic/TimeOfDayCard';
import PopularTimeCard from '../../../components/dashboard/traffic/PopularTimeCard';

export default function TrafficAnalyticsByTime() {

    return (
       <Fragment>
           <PopularTimeCard />
           <TimeOfDayCard />
           <CountByHourCard />
        </Fragment>
    )
}